import api from "../../../core/api";
import { Page } from "../../../shared/models/models";
import { ChangeRfq, Rfq, RfqsQuery } from "../models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.tradingBaseUrl };
}

class BuyerRfqsApi {
  getRfqsAsync(query: RfqsQuery): Promise<Page<Rfq>> {
    return api.get<Page<Rfq>>(
      `/v1/buyer/quotation-requests`, { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } })
      .then(x => x.data);
  }

  getRfqAsync(id: string): Promise<Rfq>{
    return api.get<Rfq>(`/v1/buyer/quotation-requests/${id}`, getRequestConfig()).then(x => x.data);
  }

  createRfqAsync(model: ChangeRfq): Promise<string> {
    return api.post<string>(`/v1/buyer/quotation-requests`, model, getRequestConfig())
      .then(x => x.data);
  }

  closeRfq(id: string) {
    return api.put<any>(`/v1/buyer/quotation-requests/${id}/close`, null, getRequestConfig());
  }

  deleteRfq(id: string): Promise<any> {
    return api.delete(`/v1/buyer/quotation-requests/${id}`, getRequestConfig());
  }
}

export default new BuyerRfqsApi();